import React, { Component } from 'react'
import Container from 'muicss/lib/react/container'
import ListHeaderNav from './ListHeaderNav'
import ItemList from './ItemList.jsx'
import { Link } from 'react-router'
import Loader from './Loader.jsx'
import Nodata from './Nodata.jsx'
import util from '../util'
import _ from 'lodash'

export default class Category extends Component {
  constructor(props) {
    super(props);
    this.state = {q: props.location.query['q']}
  }
  changeQ(e) {
    this.setState({q: e.target.value})
  }
  keyPressOnQuery(e) {
    if (e.charCode == 13) {
      this.props.open(this.props.location.pathname, {q:this.state.q})
    }
  }

  render() {
    const {
      items, category, featureId,  images,
      openDetail, routeParams: {itemId}, loading,
      feature, error,
      loadNextPage, waitingNextPage, categories, endOfList
          } = this.props
    let showPrice = x => x ? '¥' + Number(x).toLocaleString() : ''
    let prices = [
      {name: 'すべて', reset: true},
      {'price-from': '0',    'price-to': '999'},
      {'price-from': '1000', 'price-to': '2999'},
      {'price-from': '3000', 'price-to': '3999'},
      {'price-from': '4000', 'price-to': '4999'},
      {'price-from': '5000', 'price-to': '6999'},
    ].map((x, k) => {
      const pick = y => _.pick(y, ['price-from', 'price-to'])
      const nq = pick(x);
      const active = _.isEqual(nq, pick(this.props.location.query))
      const query = x.reset ? _.omit(this.props.location.query, ['price-from', 'price-to']) : {...this.props.location.query, ...nq}
      return (
        <li key={k}>
            <Link to={this.props.location.pathname}
                  query={query}
                  className={active ? '--active' : null} >
                {x.name || showPrice(x['price-from']) + '〜' + showPrice(x['price-to'])}
            </Link>
        </li>
      )
    });

    const search = category && _.startsWith(category.slug, 'general') ? (
      <div className="searchbox">
          <input className="searchbox__input" placeholder="キーワード" type="text" value={this.state.q} onChange={this.changeQ.bind(this)} onKeyPress={this.keyPressOnQuery.bind(this)} />
          <Link className="searchbox__link" to={this.props.location.pathname} query={{q:this.state.q}}>検索</Link>
      </div>
    ) : null

    const image = category ? category.image : null
    const title = category ? category.title : feature ? feature.name : ''
    const slug = _.get(category, 'slug')
    const basePath = category ? `/categories/${category.slug}` :
          `/features/${featureId}`

    const vNavHeader = !util.isStandaloneFeature(featureId) ? <ListHeaderNav /> : <div className="list-header__nav"/>

    const vWarn = items.length >= 1000 && category && (
      <p className="result-message">※1,000件を超えたアイテムは表示されていません。必要に応じ条件を指定して絞り込んでください。</p>
    )
    const vContent = (() => {
      if(!loading && items.length === 0) {
        return <Nodata />
      } else {
        return (
            <ItemList data={items} images={images}
                      basePath={basePath}
                      withoutCarriage={util.isUndeliverableFeature(featureId)}
                      shouldSubtractCarriage={util.shouldCarriageOfItemsInFeatureSubtracted(featureId)}
                      itemId={itemId} query={this.props.location.query}
                      enableScroll={this.props.enableScroll}/>
        )
      }
    })()
    const vError = error && (
      <div>
        <p>申し訳ございません。エラーが発生しました。<br/></p>
        <p>{error.message}</p>
        <code>{error.stack}</code>
      </div>
    )

    const loadNextPageButton = waitingNextPage && !loading && (
        <div className="mui--text-center" >
        <button onClick={loadNextPage} className="mui-btn mui-btn--flat mui-btn--primary">続きを読み込む</button>
        </div>
    )

    const endOfListText = endOfList && !waitingNextPage && (
        <div className="mui--text-center" >
        <p>商品は以上です。</p>
        </div>
    )

    const vFeatureDescription =  feature.items ? (() => {
      if (!this.props.location.query.category) {
        if (featureId.indexOf("wildcard-kfov") == 0) {
          return <div></div>
        }
        return (
          <div className="list-header__sub_title">
              <span>現在の商品掲載数: {feature.items.length}</span>
          </div>)
      } else {
        let category = _.find(categories, x => x.slug == this.props.location.query.category)
        return (
          <div className="list-header__sub_title">
              <span>「{category.userTitle || category.title}」の商品一覧</span>
          </div>)
      }
    } )(): null

    const vCategories = categories.filter(x => !x.endOfReception).map((x, k) => {
      const active = _.isEqual(x.slug, this.props.location.query.category)
      return (
        <li key={k}>
            <Link to={this.props.location.pathname}
                  query={{category: x.slug}}
                  className={active ? '--active' : null} >
                {x.userTitle || x.title}
            </Link>
        </li>
      )
    })
    vCategories.unshift((
        <li key={'all'}>
            <Link to={this.props.location.pathname}
                  className={!this.props.location.query.category ? '--active' : null} >
                {'全て'}
            </Link>
        </li>
    ))

    return (
      <div>
          <div className="list-header --water">
              <Container>
                  {vNavHeader}
                  <div className="list-header__content">
                      <h1 className="list-header__title">
                          { image && <img className="list-header__icon" src={image} /> }
                          {title}
                      </h1>
                      { feature && feature.isWildCard && vFeatureDescription }
                      <div className="list-header__search">
                        {search}
                        <ul className="search-links">
                            {false && category && prices}
                            {feature && feature.isWildCard && !feature.noCategoryWildCard && vCategories}
                        </ul>
                      </div>
                  </div>
              </Container>
          </div>
          {vWarn}
          {vContent}
          {loading && <Loader/>}
          {vError}
          {loadNextPageButton}
          {endOfListText}
      </div>
    )
  }

  componentDidMount() {
    this.props.hundleOnMout()
  }

  componentDidUpdate(prevProps){
    this.props.handleDidUpdate(prevProps, this.props)
  }
}



// WEBPACK FOOTER //
// ./src/components/Category.js